import { ForgotPasswordForm } from '@/features/auth';
import { setPageTitle } from '@/lib/utils';

export function ForgotPasswordPage() {
  setPageTitle('Forgot Password');
  return <ForgotPasswordForm />;
}
